/**
 * Le magasin d'une course ou d'un item de catalogue.
 * Décisions : [ADR 0011](../../../docs/adr/0011-deux-magasins-courses-catalogue.md).
 *
 * Le type vit ici et non dans `stores/shop.ts` pour que `api/` puisse l'importer sans
 * dépendre de l'état de l'UI — sinon `stores/courses → api/courses → stores/shop` fait
 * un cycle.
 */

export const STORES = ['lafourche', 'carrefour'] as const;

export type Store = (typeof STORES)[number];

export const STORE_LABELS: Record<Store, string> = {
  lafourche: 'La Fourche',
  carrefour: 'Carrefour',
};

export function otherStore(store: Store): Store {
  return store === 'lafourche' ? 'carrefour' : 'lafourche';
}

export function isStore(raw: unknown): raw is Store {
  return typeof raw === 'string' && (STORES as readonly string[]).includes(raw);
}
